//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/TaggedObjectCollection.js";
import "../no/ugmath.js";
import "../Assemblies/Assemblies.SubsetBuilder.js";
let d=[[],[[["journalIdentifier"],"FindObject",{R_:{searchTerm:"Assemblies.SearchTerm"}},1,0],[["logicType","searchResultElement"],"CreateExplicitSearchTerm",{R_:{explicitSearchTerm:"Assemblies.ExplicitSearchTerm"}},2,0],[["logicType","searchResultElements"],"CreateExplicitSearchTermGroup",{R_:{groupTerm:"Assemblies.GroupSearchTerm"}},2,0],[["searchTermBuilder"],"AddSearchTermBuilder",{},1,0],[["logicType","overlapType","bottomCorner","topCorner","trueShapeRefinement"],"CreateBoxSearchTerm",{R_:{boxSearchTerm:"Assemblies.BoxSearchTerm"}},5,0],[["logicType","seeds","distance","trueShapeRefinement"],"CreateProximitySearchTerm",{R_:{proximitySearchTerm:"Assemblies.ProximitySearchTerm"}},4,0],[["logicType","seedRunName","distance","trueShapeRefinement"],"CreateRunContentProximitySearchTerm",{R_:{runContentProximitySearchTerm:"Assemblies.RunContentProximitySearchTerm"}},4,0],[["logicType","overlapType","normal","displacement","pointOnPlane","trueShapeRefinement"],"CreatePlaneSearchTerm",{R_:{planeSearchTerm:"Assemblies.PlaneSearchTerm"}},6,0],[["logicType","queryName","entries","values"],"CreateAttributeSearchTerm",{R_:{attributeSearchTerm:"Assemblies.AttributeSearchTerm"}},4,0],[["logicType","partition"],"CreatePartitionSearchTerm",{R_:{partitionSearchTerm:"Assemblies.PartitionSearchTerm"}},2,1],[["logicType","partitions"],"CreatePartitionSearchTermGroup",{R_:{groupTerm:"Assemblies.GroupSearchTerm"}},2,1],[["logicType","includeChildrenLogic","partition"],"CreatePartitionSearchTerm1",{R_:{partitionSearchTerm:"Assemblies.PartitionSearchTerm"}},3,0],[["logicType","includeChildrenLogic","partitions"],"CreatePartitionSearchTermGroup1",{R_:{groupTerm:"Assemblies.GroupSearchTerm"}},3,0],[["searchTerm"],"MoveUp",{},1,0],[["searchTerm"],"MoveDown",{},1,0],[["logicType","searchTerms"],"Group",{},2,0],[["searchTerms"],"Ungroup",{},1,0],[["searchTerms"],"DeleteSearchTerms",{},1,0],[["logicType","searchTerms"],"SetSearchTermLogic",{},2,0],[["logicType","includeChildrenLogic","searchTerms"],"SetPartitionSearchTermLogic",{},3,0],[["optionSet","searchOption","optionValue"],"SetSearchOptionValue",{},3,0],[["optionSet","searchOption"],"GetSearchOptionValue",{R_:{optionValue:''}},2,0],[["optionSet","nSearchOptions"],"GetAllSearchOptions",{R_:{searchOptions:""}},1,0],[["nOptionSets"],"GetAllSearchOptionSets",{R_:{optionSets:""}},0,0]],[]];
SPLM.Assemblies.SubsetRecipe = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Assemblies.SubsetRecipe";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;